<script setup>
    import { isObject,isString } from "@/libs/utils";
	
    const props = defineProps({
        to: {
            type: [Object,String],
            default: {}
        },
        style: {
            type: Object,
            default: {}
        }
    })
    
    const emits = defineEmits(['change']);

    const link = (value)=>{
        if(isString(value)){
            return value.length > 0 ? value : "";
        }else if(isObject(value)){
            if(value.path == undefined){
                return "";
            }else if(value.path.length <= 0){
                return "";
            }

            return value.path;
        }

        return "";
    }

    const onChange = ()=>{
        emits("change");
    }
</script>

<template>
    <router-link :to="link(props.to)" v-if="link(props.to).length > 0" @click="onChange" :style="props.style">
        <slot></slot>
    </router-link>
    <template v-else>
        <slot></slot>
    </template>
</template>

<style lang="scss" scoped>

</style>